import { useState, useEffect, useRef } from "react";
import { useSelector, useDispatch } from "react-redux";
import { addCustomer, updateCustomer } from "../../../../redux/actions/customerForm";
import { loadBergenBillingOption } from "../../../../redux/actions/bergenBillingOption";
import { loadShippingMethod } from "../../../../redux/actions/shippingMethod";
import { loadOrderStatus } from "../../../../redux/actions/customerSection";
import { getCustomerTerm } from "../../../../redux/actions/customerTerm.action";
import { getOneCustomer } from "../../../../redux/actions/CustomerFormById";
import { getCustomerType } from "../../../../redux/actions/customerType.action";
import { loadFreightTerm } from "../../../../redux/actions/freightTerm";
import { getAllCompany } from "../../../../redux/actions/companyAccess";
import { loadShipVia } from "../../../../redux/actions/shipVia";
import { getSystemLog } from "../../../../redux/actions/systemLog.action";
import { getBilling, getRelatedTransactions } from "../../../../redux/actions/billing";
import Swal from "sweetalert2";
import SubTitle from "../../../../components/SubTitle/SubTitle";
import Tables from "../../../../components/Table/Tables";
import {
  CloudDownloadOutlined,
  DeleteOutlined,
  InboxOutlined,
  EyeOutlined
} from "@ant-design/icons";
import { Button, Form, Input, Checkbox, Tabs, Divider, Select, DatePicker, Space, Modal, Upload, Collapse, List, Table, Popconfirm, Image, message } from "antd";
import BillingSection from "../../billingSection";
import CategorySection from "../../categorySection";
import notification from "../../../../utils/notification";
import { Row as Brow, Col as Bcol } from "reactstrap";
import { ReadCookie } from "../../../../utils/readCookie";
import "../../../Style/style.css";
import "../../customer.css";
import "../../../Product/product.css";
import { getShipping } from "../../../../redux/actions/shipping";
import {
  addCategory,
  deleteCategory,
  loadCategory,
  updateCategory,
} from "../../../../redux/actions/customerCategory";
import { loadSalePerson } from "../../../../redux/actions/salePerson/salePersonForm.action";
import { getRegion } from "../../../../redux/actions/region.action";
import { getPaymentTerm } from "../../../../redux/actions/paymentterm.action";
import {
  addCustomerUpload,
  deleteCustomerFile,
  getCustomerUpload,
} from "../../../../redux/actions/customer.upload.action";
import {
  addCustomerAddress,
  deleteAddress,
  getOneCustomerAddress,
  updateAddress,
} from "../../../../redux/actions/customerAddress.action";
import moment from "moment";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import { relatedTransactions } from "../../../../utils/cols";
import Loader from "react-loader-spinner";
import { getSaleOrderAdjustmentFormData } from "../../../../redux/actions/saleOrderAdjustment.action";
import { getBrands } from "../../../../redux/actions/brand.action";
import { BASEURL } from "../../../../constant/config";
import axios from "axios";

export default function CustomerNewForm({
  token,
  submit,
  submitForm,
  setDisable,
  formState,
  changeState,
  formData,
  customerAllIdd,
  menuId
}) {
  const focusInput = useRef(null);
  const { TextArea } = Input;
  const { Dragger } = Upload;
  const { Panel } = Collapse;
  const history = useHistory();
  const [form] = Form.useForm();
  const { TabPane } = Tabs;
  const { Option } = Select;
  const [loading, setLoading] = useState(false);
  const [companyId, setCompanyId] = useState(ReadCookie("defaultCompany"));

  const dispatch = useDispatch();
  const [fileList, setFileList] = useState([]);
  const {
    ShipVia,
    ShippingMethod,
    FreightTerm,
    BergenBillingOption,
    systemLog,
    customerTypes,
    customerSections,
    companyAll,
    customerTerm,
    customerUploads,
    saleOrderAdjustmentFormData,
    brand,
  } = useSelector((state) => state);
  const [categoryData, setCategoryData] = useState([]);
  const [customerID, setCustomerId] = useState("");

  const [expireDate, setExpiryDate] = useState(null);
  const [relatedTrans, setRelatedTrans] = useState([]);

  const [billingAddress, setBillingAddress] = useState([]);
  const [deletedBillingLine, setDeletedBillingLine] = useState([]);
  const [deletedCategoryLine, setDeletedCategoryLine] = useState([]);

  // Communication
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [fileRemark, setFileRemark] = useState(null);
  const [documentType, setDocumentType] = useState("pdf");
  const [folderType, setFolderType] = useState(null);
  const [errors, setErrors] = useState({});

  const [fileViewModalOpen, setIsFileViewModalOpen] = useState(false);
  const [selectedFile, setIsSelectedFile] = useState(null);

  const onSearch = (val) => {
    if (val.length > 2) {
      dispatch(
        getSaleOrderAdjustmentFormData(token, companyId, menuId, val, "")
      ).then((res) => {
        if (
          res.type === "GET_GENDER_HEADER_DATA_SUCCESS" &&
          res?.payload.length === 0
        ) {
          notification("warning", "empty List");
        }

        if (res?.payload?.customerDetail?.length === 0) {
          notification("warning", "Customer Not Found");
        }
      });
    }
  };

  useEffect(() => {
    if (companyId) {
      setCompanyId(parseInt(companyId));
      form.setFieldsValue({
        company: companyId,
      });
    }
    dispatch(getAllCompany(token));
  }, [companyId]);

  useEffect(() => {
    dispatch(loadSalePerson(token));
    dispatch(getRegion(token));
    dispatch(getPaymentTerm(token));
    dispatch(getCustomerType(token));
    dispatch(loadFreightTerm(token));
    dispatch(loadShippingMethod(token));
    dispatch(loadBergenBillingOption(token));
    dispatch(getCustomerTerm(token));
    dispatch(getAllCompany(token));
    dispatch(loadShipVia(token));
    dispatch(loadOrderStatus(token))
    dispatch(getAllCompany(token));
    dispatch(
      getSaleOrderAdjustmentFormData(token, companyId, menuId, null, null)
    );
    dispatch(getBrands(token));
  }, []);

  var paymentTermActive = customerTerm?.payload?.data.filter((t) => {
    return t.is_active === true
  })

  let dBill =
    billingAddress && billingAddress.find((val) => val.default_bill_to == true);

  useEffect(() => {
    if (formData) {

      form.setFieldsValue({
        company: formData?.company_id,
        customer_id: formData?.customer_code,
        customerName: formData?.customer_name,
        customerType: formData?.customer_type_id,
        webAddress: formData?.website,
        comments: formData?.remarks,
        discount_offer: formData?.discount_offer,
        credit_limit: formData?.credit_limit,
        paymentTerm: formData?.term_id,
        fTaxID: formData?.federal_tax_id,

        firstName: formData?.first_name,
        lastName: formData?.last_name,
        email: formData?.email_address,
        otherEmails: formData?.alternate_email_address,
        secondary_email: formData?.secondary_email,
        phone: formData?.phone_no,
        fax: formData?.fax_no,
        address: formData?.address,

        orderStatus: formData?.order_status_id,
        oldID: formData?.old_customer_code,
        rcn: formData?.resale_certificate_no,

        shippingMethod: formData?.shipping_method_id,
        freightTerm: formData?.freight_term_id,
        bergenBilling: formData?.bergan_billing_id,
        orderType: formData?.order_type_id,


        shipVia: formData?.bergan_ship_via_id,
        accountNo: formData?.shipping_account_no,
        taxDuties: formData?.tax_duties,
        shipToNonUs: formData?.ship_to_non_us,
        billToNonUs: formData?.bill_to_non_us,
        alcoholType: formData?.alcohol_recipient_type,
        isApproved: formData?.is_approved,
        isactive: formData?.is_active,
        min_surcharge_waived: formData?.min_surcharge_waived,
        high_priority_account: formData?.high_priority_account,
        complete_naf: formData?.complete_naf,
        isComplete: formData?.is_ship_complete,
        brand_id: formData?.brand_name ? getBrandId(formData?.brand_name) : null,

        dBillAdd:
          dBill &&
          dBill?.address_addressee +
          "\n" +
          dBill?.address_address_1 +
          (dBill?.address_address_2 != null
            ? "\n" + dBill?.address_address_2
            : "") +
          "\n" +
          dBill?.address_city_name +
          " " +
          (dBill?.address_state_name != null
            ? dBill?.address_state_name + " "
            : "") +
          dBill?.address_zip_code +
          "\n" +
          dBill?.address_country_name,
        expiryDate:
          formData?.resale_certificate_date === null
            ? null
            : moment(formData?.resale_certificate_date),
      });
      setCustomerId(formData.customer_id);
      if (formData.customer_id) {
        dispatch(loadCategory(token, formData.customer_id)).then((res) => {
          setCategoryData(res?.payload?.data);
        });
      }
    }
  }, [formData, dBill]);


  useEffect(() => {
    if (submitForm) {
      onFinish()
    }
  }, [submitForm]);

  const getBrandId = (brandName) => {
    const i = (brand.payload.data || []).findIndex(x => x.brand_name === brandName)
    return i >= 0 ? brand.payload.data[i].brand_id : null
  }

  const handleTab = (key) => {
    if (key === "shipping") {
      return dispatch(getShipping(token, customerID));
    }
    if (key === "billing") {
      return dispatch(getBilling(token, customerID));
    }
    if (key === "logs") {
      return dispatch(
        getSystemLog(token, {
          table_name: "scm_customer_communication",
          record_id: customerID,
        })
      );
    }
    if (key === "communication") {
      return dispatch(getCustomerUpload(token, customerID));
    }
    if (key === "relatedTransactions") {
      return dispatch(getRelatedTransactions(token, customerID)).then((res) => {
        setRelatedTrans(res?.payload?.data);
      });
    }
  };

  useEffect(() => {
    if (formState === "view" || formState === "table" || formState === "add") {
      setCustomerId("");
      form.setFieldsValue({
        customer_id: null,
        customerName: null,
        customerType: null,
        webAddress: null,
        comments: null,
        credit_limit: null,
        brand_id: null,
        discount_offer: null,

        firstName: null,
        lastName: null,
        email: null,
        otherEmails: null,
        secondary_email: null,
        phone: null,
        fax: null,
        address: null,
        min_surcharge_waived: null,
        high_priority_account: null,
        complete_naf: null,

        orderStatus: 1,
        oldID: null,
        rcn: null,
        expiryDate: expireDate,
        fTaxID: null,


        shippingMethod: null,
        freightTerm: null,
        bergenBilling: null,
        orderType: null,
        shipVia: null,
        accountNo: null,
        taxDuties: null,
        shipToNonUs: null,
        billToNonUs: null,
        alcoholType: null,
        isApproved: null,
        isactive: null,
        isComplete: null,
        paymentTerm: null,
      });
    }
  }, [formState]);

  let HeaderId;


  const onFinish = async (e) => {
    submit(false);
    setDisable(true);
    setLoading(true);
    let checkBilling_Shipping = false;
    billingAddress.slice(0, 2).map((v) => {
      if (v?.default_bill_to || v?.default_ship_to) {
        checkBilling_Shipping = true;
      } else if (billingAddress[0].default_bill_to && billingAddress[0].default_ship_to) {
        checkBilling_Shipping = true;
      } else {
        checkBilling_Shipping = false;
        setLoading(false);
        setDisable(false);
        return Swal.fire({
          icon: "error",
          title: "Oops...",
          text: "There should be one default billing and default shipping address",
        });
      }
    })

    if (!form.getFieldValue().shipVia) {
      setLoading(false);
      setDisable(false);
      return Swal.fire({
        icon: "error",
        title: "Oops...",
        text: "Select the Ship Via in Preferences",
      });
    }
    if (!form.getFieldValue().freightTerm) {
      setLoading(false);
      setDisable(false);
      return Swal.fire({
        icon: "error",
        title: "Oops...",
        text: "Select the Freight Term in Preferences",
      });
    }
    if (categoryData.length === 0) {
      setLoading(false);
      setDisable(false);
      return Swal.fire({
        icon: "error",
        title: "Oops...",
        text: "Select At Least One Category",
      });
    }

    await form.validateFields().then((values) => {
      if (formState === "add") {
        if (billingAddress?.length > 0) {
          if (checkBilling_Shipping) {
            dispatch(addCustomer(token, values)).then((res) => {
              if (res.type === "ADD_CUSTOMER_ERROR") {
                setLoading(false);
                setDisable(false);
                notification(
                  "error",
                  res?.payload?.request?.statusText,
                  res?.payload?.data?.data
                );
              }
              if (res.type === "ADD_CUSTOMER_SUCCESS") {
                HeaderId = res?.payload?.customer_id;
                dispatch(getOneCustomer(token, res?.payload?.customer_id)).then(
                  (res) => {
                    form.setFieldsValue({
                      customer_id: res?.payload?.customer_code,
                    });
                    dispatch(
                      addCustomerAddress(
                        token,
                        billingAddress.map((v) => (
                          delete v.index,
                          {
                            ...v,
                            customer_id: res?.payload?.customer_id,
                          }))
                      )
                    ).then((response) => {
                      if (response.type === "ADD_CUSTOMER_ADREESS_SUCCESS") {
                        dispatch(getOneCustomerAddress(token, HeaderId)).then(
                          (res) => {
                            setBillingAddress(res?.payload?.data);
                          }
                        );
                        if (categoryData.length > 0) {
                          categoryData.map((sell) => {
                            delete sell.gender_name;
                            delete sell.region_name;
                            delete sell.salesperson_name;
                            return (sell.customer_id = res?.payload?.customer_id);
                          });
                          dispatch(
                            addCategory(token, categoryData, HeaderId)
                          ).then((res) => {
                            if (res.type === "ADD_CATEGORY_SUCCESS") {
                              dispatch(loadCategory(token, HeaderId));
                            }
                          });
                        }
                        notification(
                          "success",
                          res?.payload?.request?.statusText,
                          "Customer created successfully!"
                        );
                        setLoading(false);
                        setDisable(false);
                        changeState("formView");
                        history.push({
                          pathname: `/customer-New-Info/edit/${HeaderId}`,
                          search: `?edit=yes`,
                        });
                      }
                    });
                  }
                );
              }
            });
          }
        } else {
          setLoading(false);
          setDisable(false);
          Swal.fire({
            icon: "error",
            title: "Oops...",
            text: "Add At least One Address",
          });
          return;
        }
      } else if (formState === "edit") {
        if (deletedBillingLine.length > 0) {
          dispatch(deleteAddress(token, customerAllIdd, deletedBillingLine));
        }
        if (deletedCategoryLine.length > 0) {
          dispatch(deleteCategory(token, customerAllIdd, deletedCategoryLine));
        }
        values.is_active = form.getFieldValue().isactive;
        if (checkBilling_Shipping) {
          dispatch(updateCustomer(token, values, customerAllIdd)).then((res) => {
            if (res.type === "UPDATE_CUSTOMER_ERROR") {
              setLoading(false);
              setDisable(false);
              notification("error", "Update", "Something went wrong");
            }
            if (res.type === "UPDATE_CUSTOMER_SUCCESS") {
              dispatch(
                updateAddress(token, billingAddress.filter((v) => v.is_edited), formData?.customer_id)
              ).then((res) => {
                if (res.type === "UPDATE_CUSTOMER_ADREESS_SUCCESS") {
                  if (categoryData.length > 0) {
                    categoryData.map((sell) => {
                      delete sell.gender_name;
                      delete sell.region_name;
                      delete sell.salesperson_name;
                      delete sell.last_updated_by;
                      delete sell.last_updated_date;
                      delete sell.key;

                      return (sell.customer_id = formData?.customer_id);
                    });
                    dispatch(
                      updateCategory(token, categoryData, formData?.customer_id)
                    ).then((res) => {
                      if (res.type === "UPDATE_CATEGORY_SUCCESS") {
                        dispatch(loadCategory(token, formData?.customer_id)).then(
                          (response) => {
                            setCategoryData(response?.payload?.data);
                          }
                        );
                      }
                    });
                  }
                  dispatch(
                    getOneCustomerAddress(token, formData?.customer_id)
                  ).then((res) => {
                    setBillingAddress(res?.payload?.data);
                  });
                  dispatch(getOneCustomer(token, formData?.customer_id));
                  setLoading(false);
                  setDisable(false);
                  notification(
                    "success",
                    "Customer update",
                    "Customer updated successfully"
                  );
                  changeState("formView");
                }
              });
            }
          });
        }
      }
    }).catch(err => {
      setDisable(false);
      setLoading(false);
    });
  };

  const renderColumns = () => {
    const keys = Object.keys(systemLog?.payload?.data[0]);
    return keys.map((it, i) => {
      return {
        title: it,
        dataIndex: it,
        key: i.toString(),
      };
    });
  };

  const uploadProps = {
    action: "https://httpbin.org/post",
    fileList: fileList, // Controlled fileList

    onChange({ file, fileList: newFileList }) {
      if (file.status !== 'error') {
        setFileList(newFileList.filter(f => f.status !== 'error'));
      }
    },

    beforeUpload: (file) => {
      const isAllowed =
        (documentType === "pdf" && file?.type === "application/pdf") ||
        (documentType === "doc" &&
          (file?.type === "application/msword" ||
            file?.type === "application/vnd.openxmlformats-officedocument.wordprocessingml.document")) ||
        (documentType === "image" &&
          (file?.type === "image/jpeg" ||
            file?.type === "image/png" ||
            file?.type === "image/jpg"));

      if (!isAllowed) {
        message.error(`Only ${documentType.toUpperCase()} files are allowed.`);
      }

      return isAllowed || Upload.LIST_IGNORE;
    },

    accept:
      documentType === "pdf"
        ? ".pdf"
        : documentType === "doc"
          ? ".doc,.docx"
          : documentType === "image"
            ? ".jpg,.jpeg,.png"
            : "",

    multiple: false,
    maxCount: 1,
  };

  const upload_columns = [
    {
      title: 'Date',
      dataIndex: 'created_date',
      key: 'created_date',
      render: (text, record) => {
        return moment(text).format("MM-DD-YYYY")
      }
    },
    {
      title: 'File Name',
      dataIndex: 'physical_file_name',
      key: 'physical_file_name',
    },
    {
      title: 'File Type',
      dataIndex: 'upload_file_type',
      key: 'upload_file_type',
    },
    {
      title: 'File Remarks',
      dataIndex: 'upload_remarks',
      key: 'upload_remarks',
    },
    {
      title: 'Operations',
      dataIndex: 'upload_remarks',
      key: 'upload_remarks',
      render: (text, record) => {
        return (
          <div style={{ display: "flex", gap: 20 }}>
            <div>
              <EyeOutlined style={{ cursor: "pointer" }}
                onClick={() => {
                  setIsFileViewModalOpen(true);
                  setIsSelectedFile(record);
                }}
              />
            </div>
            <div >
              <CloudDownloadOutlined
                style={{ cursor: "pointer" }}
                onClick={() => downloadFile(record.customer_communication_id)}
              />
            </div>
            <div>
              {
                formState === "edit" && (
                  <Popconfirm
                    placement="topLeft"
                    title={`Are you sure to delete this File (${record.physical_file_name})?`}
                    onConfirm={() => {
                      dispatch(deleteCustomerFile(token, record.customer_communication_id)).then((res) => {
                        if (res.type === "DELETE_CUSTOMER_FILE_SUCCESS") {
                          dispatch(getCustomerUpload(token, customerID))
                          Swal.fire({
                            icon: "success",
                            title: "Success...",
                            text: res?.payload?.message,
                          });
                        }
                      })
                    }}
                    okText="Yes"
                    cancelText="No"
                  >

                    <DeleteOutlined style={{ cursor: "pointer" }} />
                  </Popconfirm>
                )
              }
            </div>
          </div>
        )
      }
    },
  ];

  const renderUploadData = (value) => {
    // filter data based on value
    const filteredData = customerUploads?.payload?.data
      ?.filter((it) => it.upload_file_type === value)
      ?.map((item, index) => ({
        ...item,
        key: index,
      }));

    return (
      <Table
        size="small"
        loading={customerUploads?.loading}
        bordered
        dataSource={filteredData}
        columns={upload_columns}
        rowClassName="editable-row"
        pagination={false}
      />
    );
  };

  function getUploadCount(type) {
    const data = customerUploads?.payload?.data || [];

    if (!Array.isArray(data)) return 0;
    return data.filter(item => item.upload_file_type === type).length;
  }

  const downloadFile = async (id) => {
    try {
      const response = await axios.get(`${BASEURL}getOne/downloadCommunication/${id}`, {
        responseType: 'blob',
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      const disposition = response.headers['content-disposition'] || response.headers['Content-Disposition'];
      let fileName = 'downloaded-file';
      if (disposition) {
        const fileNameMatch = disposition.match(/filename="(.+?)"/);
        if (fileNameMatch && fileNameMatch[1]) {
          fileName = fileNameMatch[1];
        }
      }
      const url = window.URL.createObjectURL(response.data);
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', fileName);
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(url);
    } catch (error) {
      console.error('Download failed', error);
      alert('File download failed.');
    }
  };

  const getFileType = (url) => {
    if (!url) return "";
    return url.split(".").pop().toLowerCase();
  };

  const fileType = getFileType(selectedFile?.upload_file_url);

  return <>
    <div className="styleContainer">
      {/* <div className="styleBody h-100"> */}
      <div className="bodyStyle"></div>
      <div className="styleContainer">
        <div className="styleBody h-100">
          <div className="bodyStyle">
            <div className="customerContainer">
              {loading && (
                <div className="loaderDiv">
                  <Loader
                    type="Grid"
                    color="#212121"
                    height={40}
                    width={40}
                  />
                </div>
              )}
              <SubTitle name={"Primary Information"} />
              <div className="formProduct">

                <Form onFinish={onFinish} form={form} name="basic">
                  <div className="container-fluid pbpx-5 ptpx-5">
                    <Brow>
                      <Bcol lg={6} xl={4} xxl={3}>
                        <div className="customCol slc">
                          <Form.Item
                            name="company"
                            label="Company"
                            labelAlign="left"
                            labelCol={{ span: 8 }}
                            wrapperCol={{ span: 16 }}
                            initialValue={
                              formState === "add"
                                ? null
                                : form.getFieldValue().company
                            }
                          >
                            <Select
                              size="small"
                              showSearch
                              optionFilterProp="children"
                              onSearch={onSearch}
                              filterOption={(input, options) =>
                                options.children
                                  .toLowerCase()
                                  .indexOf(input.toLowerCase()) >= 0
                              }
                              disabled={
                                formState === "add" ||
                                formState === "edit" ||
                                formState === "view" ||
                                formState === "formView"
                              }
                              className="styleInput w-100"
                            >
                              {companyAll?.payload?.data.map((item) => {
                                return (
                                  <Option
                                    key={item.company_id}
                                    value={item.company_id}
                                  >
                                    {item.company_name}
                                  </Option>
                                );
                              })}
                            </Select>
                          </Form.Item>
                        </div>
                      </Bcol>
                      <Bcol lg={6} xl={4} xxl={3}>
                        <div className="customCol">
                          <div className="relative">
                            <Form.Item
                              initialValue={
                                formState === "add"
                                  ? null
                                  : form.getFieldValue().customer_id
                              }
                              rules={[
                                {
                                  pattern: new RegExp(/^[0-9\b]+$/),
                                  message: "Must be a Number",
                                },
                              ]}
                              wrapperCol={{ span: 16 }}
                              labelCol={{ span: 8 }}
                              label="Customer Code"
                              name="customer_id"
                              labelAlign="left"
                            >
                              <Input
                                bordered={false}
                                size="small"
                                className="styleInput"

                                disabled={
                                  formState === "add" ||
                                  formState === "edit" ||
                                  formState === "view" ||
                                  formState === "formView"
                                }
                              />
                            </Form.Item>
                          </div>
                        </div>
                      </Bcol>
                      <Bcol lg={6} xl={4} xxl={3}>
                        <div className="customCol">
                          <div className="relative">
                            <Form.Item
                              name="customerName"
                              label="Customer Name"
                              labelAlign="left"
                              labelCol={{ span: 8 }}
                              wrapperCol={{ span: 16 }}
                              initialValue={
                                formState === "add"
                                  ? null
                                  : form.getFieldValue().customerName
                              }
                              rules={[
                                {
                                  required: true,
                                  message: "Customer Name is required",
                                },
                              ]}
                            >
                              <Input
                                size="small"
                                className="styleInput"

                                disabled={
                                  !(
                                    formState === "add" ||
                                    formState === "edit"
                                  )
                                }
                              />
                            </Form.Item>
                          </div>
                        </div>
                      </Bcol>
                      <Bcol lg={6} xl={4} xxl={3}>
                        <div className="customCol slc">
                          <div className="relative">
                            <Form.Item
                              size="small"
                              name="customerType"
                              label="Customer Type"
                              labelAlign="left"
                              labelCol={{ span: 8 }}
                              wrapperCol={{ span: 16 }}
                              rules={[
                                {
                                  required: true,
                                  message: "Customer Type is required",
                                },
                              ]}
                            >
                              <Select
                                size="small"
                                filterSort={(optionA, optionB) =>

                                  optionA.children.toLowerCase().localeCompare(optionB.children.toLowerCase())
                                }
                                defaultValue={
                                  formState === "edit"
                                    ? form.getFieldValue().customerType
                                    : null
                                }
                                disabled={
                                  !(
                                    formState === "add" ||
                                    formState === "edit"
                                  )
                                }

                                loading={customerTypes.loading}
                                optionFilterProp="children"
                                className="w-100"
                                onSearch={onSearch}
                                showSearch
                                allowClear
                              >
                                {customerTypes?.payload?.data.map(
                                  (customer) => {
                                    return (
                                      <Option
                                        value={customer.customer_type_id}
                                      >
                                        {customer.customer_type_name}
                                      </Option>
                                    );
                                  }
                                )}
                              </Select>
                            </Form.Item>
                          </div>
                        </div>
                      </Bcol>
                      <Bcol lg={6} xl={4} xxl={3}>
                        <div className="customCol">
                          <div className="relative">
                            <Form.Item
                              name="webAddress"
                              label="Web Address"
                              labelAlign="left"
                              labelCol={{ span: 8 }}
                              wrapperCol={{ span: 16 }}
                              initialValue={
                                formState === "add"
                                  ? null
                                  : form.getFieldValue().webAddress
                              }
                            >
                              <Input
                                size="small"
                                className="styleInput"

                                disabled={
                                  !(
                                    formState === "add" ||
                                    formState === "edit"
                                  )
                                }
                              />
                            </Form.Item>
                          </div>
                        </div>
                      </Bcol>
                      <Bcol lg={6} xl={4} xxl={3}>
                        <div className="customCol">
                          <div className="relative">
                            <Form.Item
                              name="comments"
                              label="Shipping guidelines"
                              labelAlign="left"
                              labelCol={{ span: 8 }}
                              wrapperCol={{ span: 16 }}
                              initialValue={
                                formState === "add"
                                  ? null
                                  : form.getFieldValue().comments
                              }
                            >
                              <TextArea
                                size="small"
                                rows={4}
                                disabled={
                                  !(
                                    formState === "add" ||
                                    formState === "edit"
                                  )
                                }
                              />
                            </Form.Item>
                          </div>
                        </div>
                      </Bcol>
                      <Bcol lg={6} xl={4} xxl={3}>
                        <div className="customCol">
                          <div className="relative">
                            <Form.Item
                              name="discount_offer"
                              label="Discount Offered"
                              labelAlign="left"
                              labelCol={{ span: 8 }}
                              wrapperCol={{ span: 16 }}
                              initialValue={
                                formState === "add"
                                  ? null
                                  : form.getFieldValue().discount_offer
                              }
                            >
                              <Input
                                size="small"
                                disable
                                className="styleInput"

                                disabled={
                                  !(
                                    formState === "add" ||
                                    formState === "edit"
                                  )
                                }
                              />
                            </Form.Item>
                          </div>
                        </div>
                      </Bcol>
                      <Bcol lg={6} xl={4} xxl={3}>
                        <div className="customCol slc">
                          <div className="relative">
                            <Form.Item rules={[{ required: true, message: "Brand is required" }]} name="brand_id" label="Brand" labelAlign="left" labelCol={{ span: 8 }} wrapperCol={{ span: 16 }}>
                              <Select size="small" showSearch optionFilterProp="children" filterOption={(input, option) => option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0} filterSort={(optionA, optionB) => optionA.children.toLowerCase().localeCompare(optionB.children.toLowerCase())} loading={brand.loading} className="w-100">
                                {" "}
                                {brand?.payload?.data?.map((res) => (
                                  <Option key={res.brand_id} value={res.brand_id}>
                                    {res.brand_name}
                                  </Option>
                                ))}
                              </Select>
                            </Form.Item>
                          </div>
                        </div>
                      </Bcol>
                      <Bcol lg={6} xl={4} xxl={3}>
                        <div className="customCol">
                          <div className="relative">
                            <Form.Item
                              name="credit_limit"
                              label="Credit Limit"
                              labelAlign="left"
                              labelCol={{ span: 8 }}
                              wrapperCol={{ span: 16 }}
                              initialValue={
                                formState === "add"
                                  ? null
                                  : form.getFieldValue().credit_limit
                              }
                            >
                              <Input
                                size="small"
                                disable
                                className="styleInput"
                                type="number"
                                disabled={
                                  !(
                                    formState === "add" ||
                                    formState === "edit"
                                  )
                                }
                              />
                            </Form.Item>
                          </div>
                        </div>
                      </Bcol>
                    </Brow>
                  </div>
                </Form>
              </div>
              <SubTitle name={"Email | Phone | Address"} />
              <div className="formProduct">
                <Form onFinish={onFinish} form={form} name="basic">
                  <div className="container-fluid pbpx-5 ptpx-5">
                    <Brow>
                      <Bcol lg={6} xl={4} xxl={3}>
                        <div className="customCol">
                          <div className="relative">
                            <Form.Item
                              name="firstName"
                              label="AP First Name"
                              labelAlign="left"
                              labelCol={{ span: 8 }}
                              wrapperCol={{ span: 16 }}
                              initialValue={
                                formState === "add"
                                  ? null
                                  : form.getFieldValue().firstName
                              }
                              rules={[
                                {
                                  required: true,
                                  message: "AP FIRST NAME is required",
                                },
                              ]}
                            >
                              <Input
                                size="small"
                                className="styleInput"

                                disabled={
                                  !(
                                    formState === "add" ||
                                    formState === "edit"
                                  )
                                }
                              />
                            </Form.Item>
                          </div>
                        </div>
                      </Bcol>
                      <Bcol lg={6} xl={4} xxl={3}>
                        <div className="customCol">
                          <div className="relative">
                            <Form.Item
                              name="lastName"
                              label="AP Last Name"
                              labelAlign="left"
                              labelCol={{ span: 8 }}
                              wrapperCol={{ span: 16 }}
                              initialValue={
                                formState === "add"
                                  ? null
                                  : form.getFieldValue().lastName
                              }
                              rules={[
                                {
                                  required: true,
                                  message: "AP LAST NAME is required",
                                },
                              ]}
                            >
                              <Input
                                size="small"
                                className="styleInput"

                                disabled={
                                  !(
                                    formState === "add" ||
                                    formState === "edit"
                                  )
                                }
                              />
                            </Form.Item>
                          </div>
                        </div>
                      </Bcol>
                      <Bcol lg={6} xl={4} xxl={3}>
                        <div className="customCol">
                          <div className="relative">
                            <Form.Item
                              name="otherEmails"
                              label="Other Emails"
                              labelAlign="left"
                              labelCol={{ span: 8 }}
                              wrapperCol={{ span: 16 }}
                              initialValue={
                                formState === "add"
                                  ? null
                                  : form.getFieldValue().otherEmails
                              }
                              rules={[
                                {
                                  type: "email",
                                  message: "Email is not Valid",
                                },
                              ]}
                            >
                              <Input
                                size="small"
                                className="styleInput"

                                disabled={
                                  !(
                                    formState === "add" ||
                                    formState === "edit"
                                  )
                                }
                              />
                            </Form.Item>
                          </div>
                        </div>
                      </Bcol>
                      <Bcol lg={6} xl={4} xxl={3}>
                        <div className="customCol">
                          <div className="relative">
                            <Form.Item
                              name="email"
                              label="Email"
                              labelAlign="left"
                              labelCol={{ span: 8 }}
                              wrapperCol={{ span: 16 }}
                              initialValue={
                                formState === "add"
                                  ? null
                                  : form.getFieldValue().email
                              }
                              rules={[




                                {
                                  required: true,
                                  message: "Email is required",
                                },
                              ]}
                            >
                              <Input
                                size="small"
                                className="styleInput"

                                disabled={
                                  !(
                                    formState === "add" ||
                                    formState === "edit"
                                  )
                                }
                              />
                            </Form.Item>
                          </div>
                        </div>
                      </Bcol>
                      <Bcol lg={6} xl={4} xxl={3}>
                        <div className="customCol">
                          <div className="relative">
                            <Form.Item
                              name="secondary_email"
                              label="Secondary Email"
                              labelAlign="left"
                              labelCol={{ span: 8 }}
                              wrapperCol={{ span: 16 }}
                              initialValue={
                                formState === "add"
                                  ? null
                                  : form.getFieldValue().secondary_email
                              }
                              rules={[
                                {
                                  type: "email",
                                  message: "Email is not Valid",
                                },




                              ]}
                            >
                              <Input
                                size="small"
                                className="styleInput"

                                disabled={
                                  !(
                                    formState === "add" ||
                                    formState === "edit"
                                  )
                                }
                              />
                            </Form.Item>
                          </div>
                        </div>
                      </Bcol>
                      <Bcol lg={6} xl={4} xxl={3}>
                        <div className="customCol">
                          <div className="relative">
                            <Form.Item
                              name="phone"
                              label="Phone"
                              labelAlign="left"
                              labelCol={{ span: 8 }}
                              wrapperCol={{ span: 16 }}
                              initialValue={
                                formState === "add"
                                  ? null
                                  : form.getFieldValue().phone
                              }
                            >
                              <Input
                                size="small"
                                className="styleInput"

                                disabled={
                                  !(
                                    formState === "add" ||
                                    formState === "edit"
                                  )
                                }
                              />
                            </Form.Item>
                          </div>
                        </div>
                      </Bcol>
                      <Bcol lg={6} xl={4} xxl={3}>
                        <div className="customCol">
                          <div className="relative">
                            <Form.Item
                              name="fax"
                              label="fax"
                              labelAlign="left"
                              labelCol={{ span: 8 }}
                              wrapperCol={{ span: 16 }}
                              initialValue={
                                formState === "add"
                                  ? null
                                  : form.getFieldValue().fax
                              }
                            >
                              <Input
                                size="small"
                                className="styleInput"

                                disabled={
                                  !(
                                    formState === "add" ||
                                    formState === "edit"
                                  )
                                }
                              />
                            </Form.Item>
                          </div>
                        </div>
                      </Bcol>
                      <Bcol

                        lg={6}
                        xl={8}
                        xxl={5}
                      >
                        <div className="customCol">
                          <div className="relative">
                            <Form.Item
                              name="dBillAdd"
                              label="Default Billing Address"
                              labelAlign="left"
                              labelCol={{

                                xs: { span: 52 },
                                lg: { span: 52 },
                                xxl: { span: 4 },
                              }}

                              initialValue={
                                formState === "add"
                                  ? null
                                  : form.getFieldValue().dBillAdd
                              }
                            >
                              <TextArea
                                disabled
                                bordered={false}
                                size="small"
                                className="styleInput"
                                readOnly
                                placeholder=""
                                autoSize={{
                                  minRows: 2,
                                  maxRows: 6,
                                }}
                              />
                            </Form.Item>
                          </div>
                        </div>
                      </Bcol>
                    </Brow>
                  </div>
                  {/* <div className="customRow-Customer">
                    </div> */}
                </Form>
              </div>
              <SubTitle name={"Classificaion"} />
              <div className="formProduct">

                <Form onFinish={onFinish} form={form} name="basic">
                  <div className="container-fluid pbpx-5 ptpx-5">
                    <Brow>
                      <Bcol lg={6} xl={4} xxl={3}>
                        <div className="customCol slc">
                          <div className="relative">
                            <Form.Item
                              name="orderStatus"
                              label="Order Status:"
                              labelAlign="left"
                              labelCol={{ span: 8 }}
                              wrapperCol={{ span: 16 }}
                              initialValue={
                                formState === "add"
                                  ? null
                                  : form.getFieldValue().orderStatus
                              }
                              rules={[
                                {
                                  required: true,
                                  message: "Order Status is required",
                                },
                              ]}
                            >
                              <Select
                                size="small"
                                filterOption={(input, options) =>
                                  options.children
                                    .toLowerCase()
                                    .indexOf(input.toLowerCase()) >= 0
                                }
                                disabled={
                                  !(
                                    formState === "add"


                                  )
                                }
                                defaultValue={
                                  formState === "edit"
                                    ? form.getFieldValue().orderStatus
                                    : null
                                }

                                loading={customerSections.loading}
                                optionFilterProp="children"
                                className="w-100"
                                onSearch={onSearch}
                                showSearch
                                allowClear
                                filterSort={(optionA, optionB) =>
                                  optionA.children.toLowerCase().localeCompare(optionB.children.toLowerCase())
                                }
                              >
                                {customerSections?.payload?.data.map(
                                  (order) => {
                                    return (
                                      <Option value={order.order_status_id}>
                                        {order.status_name}
                                      </Option>
                                    );
                                  }
                                )}
                              </Select>
                            </Form.Item>
                          </div>
                        </div>
                      </Bcol>
                      <Bcol lg={6} xl={4} xxl={3}>
                        <div className="customCol">
                          <div className="relative">
                            <Form.Item
                              name="oldID"
                              label="Old ID"
                              labelAlign="left"
                              labelCol={{ span: 8 }}
                              wrapperCol={{ span: 16 }}
                              initialValue={
                                formState === "add"
                                  ? null
                                  : form.getFieldValue().oldID
                              }

                            >
                              <Input
                                size="small"
                                className="styleInput"

                                disabled={
                                  !(
                                    formState === "add" ||
                                    formState === "edit"
                                  )
                                }
                              />
                            </Form.Item>
                          </div>
                        </div>
                      </Bcol>
                      <Bcol lg={6} xl={4} xxl={3}>
                        <div className="customCol">
                          <div className="relative">
                            <Form.Item
                              name="rcn"
                              label="Resale Certificate"
                              labelAlign="left"
                              labelCol={{ span: 8 }}
                              wrapperCol={{ span: 16 }}
                              initialValue={
                                formState === "add" || formState === "view"
                                  ? null
                                  : form.getFieldValue().rcn
                              }
                            >
                              <Input
                                size="small"
                                className="styleInput"
                                disabled={
                                  !(
                                    formState === "add" ||
                                    formState === "edit"
                                  )
                                }
                              />
                            </Form.Item>
                          </div>
                        </div>
                      </Bcol>
                      <Bcol lg={6} xl={4} xxl={3}>
                        <div className="customCol">
                          <div>
                            <Form.Item
                              name="expiryDate"
                              label="Resale Expiry Date"
                              labelAlign="left"
                              labelCol={{ span: 8 }}

                            >
                              {form.getFieldValue().expiryDate == null ? (
                                <DatePicker
                                  size="small"
                                  className="styleInput customInputs w-100"
                                  placeholder="Not Available"
                                  disabled={
                                    !(
                                      formState === "add" ||
                                      formState === "edit"
                                    )
                                  }
                                  format={"MM/DD/YYYY"}
                                  onChange={(e) => {
                                    setExpiryDate(moment(e));
                                  }}
                                />
                              ) : (
                                <DatePicker
                                  size="small"
                                  className="styleInput customInputs w-100"

                                  disabled={
                                    !(
                                      formState === "add" ||
                                      formState === "edit"
                                    )
                                  }
                                  format={"MM/DD/YYYY"}
                                />
                              )}
                            </Form.Item>
                          </div>
                        </div>
                      </Bcol>
                      <Bcol lg={6} xl={4} xxl={3}>
                        <div className="customCol">
                          <div className="relative">
                            <Form.Item
                              name="paymentTerm"
                              label="Payment Term:"
                              labelAlign="left"
                              labelCol={{ span: 8 }}
                              wrapperCol={{ span: 16 }}
                              initialValue={
                                formState === "add"
                                  ? null
                                  : form.getFieldValue().paymentTerm
                              }
                              rules={[
                                {
                                  required: true,
                                  message: "Payment Term is required",
                                },
                              ]}
                            >
                              <Select
                                size="small"
                                filterOption={(input, options) =>
                                  options.children
                                    .toLowerCase()
                                    .indexOf(input.toLowerCase()) >= 0

                                }
                                filterSort={(optionA, optionB) =>
                                  optionA.children.toLowerCase().localeCompare(optionB.children.toLowerCase())
                                }
                                disabled={
                                  !(
                                    formState === "add" ||
                                    formState === "edit"
                                  )
                                }
                                defaultValue={
                                  formState === "edit"
                                    ? form.getFieldValue().paymentTerm
                                    : null
                                }

                                loading={customerTerm.loading}
                                optionFilterProp="children"
                                className="w-100"
                                onSearch={onSearch}
                                showSearch
                                allowClear
                              >

                                {paymentTermActive?.map((e) => {
                                  return (
                                    <Option key={e.term_id} value={e.term_id} disabled={!e.is_active}>
                                      {e.term_name}
                                    </Option>
                                  );
                                })}
                              </Select>
                            </Form.Item>
                          </div>
                        </div>
                      </Bcol>
                      <Bcol lg={6} xl={4} xxl={3}>
                        <div className="customCol">
                          <div className="relative">
                            <Form.Item
                              name="fTaxID"
                              label="Federal Tax ID"
                              labelAlign="left"
                              labelCol={{ span: 8 }}
                              wrapperCol={{ span: 16 }}
                              initialValue={
                                formState === "add"
                                  ? null
                                  : form.getFieldValue().fTaxID
                              }
                            >
                              <Input
                                size="small"
                                className="styleInput"

                                disabled={
                                  !(
                                    formState === "add" ||
                                    formState === "edit"
                                  )
                                }
                              />
                            </Form.Item>
                          </div>
                        </div>
                      </Bcol>
                    </Brow>
                  </div>
                </Form>
              </div>
              <Divider />
              <div className="styleTab">
                <Tabs
                  size="small"
                  type="card"
                  tabBarGutter={1}
                  defaultActiveKey="billing"
                  centered
                  onChange={(key) => handleTab(key)}
                >
                  <TabPane tab="Address" key="Address">
                    <div className="tabs">
                      <BillingSection
                        customer_id={customerID}
                        formState={changeState}
                        formType={formState}
                        token={token}
                        billingAddress={billingAddress}
                        setBillingAddress={setBillingAddress}
                        deletedBillingLine={deletedBillingLine}
                        setDeletedBillingLine={setDeletedBillingLine}
                        menuId={menuId}
                      />
                    </div>
                  </TabPane>
                  <TabPane tab="Category" key="category">
                    <div className="tabs">
                      <CategorySection
                        setCategoryData={setCategoryData}
                        customer_id={customerID}
                        formState={changeState}
                        formType={formState}
                        token={token}
                        categoryData={categoryData}
                        deletedCategoryLine={deletedCategoryLine}
                        setDeletedCategoryLine={setDeletedCategoryLine}
                        menuId={menuId}
                      />
                    </div>
                  </TabPane>
                  <TabPane tab="Preferences" key="preferenceSection">
                    <div className="tabs">
                      <br />
                      <Form onFinish={onFinish} form={form} name="basic">
                        <div className="container-fluid">
                          <Brow>
                            <Bcol lg={6} xl={4} xxl={3}>
                              <div className="customCol slc">
                                <div className="relative">
                                  <Form.Item
                                    name="shippingMethod"
                                    label="Shipping Method:"
                                    labelAlign="left"
                                    labelCol={{ span: 8 }}
                                    wrapperCol={{ span: 16 }}
                                    rules={[
                                      {
                                        required: true,
                                        message:
                                          "Shipping Method is required",
                                      },
                                    ]}
                                  >
                                    <Select
                                      size="small"
                                      showSearch
                                      optionFilterProp="children"
                                      onSearch={onSearch}
                                      filterOption={(input, options) =>
                                        options.children
                                          .toLowerCase()
                                          .indexOf(input.toLowerCase()) >= 0
                                      }
                                      loading={customerSections.loading}
                                      disabled={
                                        !(
                                          formState === "add" ||
                                          formState === "edit"
                                        )
                                      }
                                      defaultValue={
                                        formState === "edit"
                                          ? form.getFieldValue()
                                            .shippingMethod
                                          : null
                                      }
                                      className="w-100"

                                      allowClear
                                      filterSort={(optionA, optionB) =>
                                        optionA.children.toLowerCase().localeCompare(optionB.children.toLowerCase())
                                      }
                                    >
                                      {ShippingMethod?.payload?.data.map(
                                        (shipMethod) => {
                                          return (
                                            <Option
                                              value={
                                                shipMethod.shipping_method_id
                                              }
                                            >
                                              {
                                                shipMethod.shipping_method_name
                                              }
                                            </Option>
                                          );
                                        }
                                      )}
                                    </Select>
                                  </Form.Item>
                                </div>
                              </div>
                            </Bcol>

                            <Bcol lg={6} xl={4} xxl={3}>
                              <div className="customCol slc">
                                <div className="relative">
                                  <Form.Item
                                    name="freightTerm"
                                    label="Freight Term:"
                                    labelAlign="left"
                                    labelCol={{ span: 8 }}
                                    wrapperCol={{ span: 16 }}
                                    rules={[
                                      {
                                        required: true,
                                        message: "Freight Term is required",
                                      },
                                    ]}
                                  >
                                    <Select
                                      size="small"
                                      showSearch
                                      optionFilterProp="children"
                                      onSearch={onSearch}
                                      filterOption={(input, options) =>
                                        options.children
                                          .toLowerCase()
                                          .indexOf(input.toLowerCase()) >= 0
                                      }
                                      loading={FreightTerm.loading}
                                      disabled={
                                        !(
                                          formState === "add" ||
                                          formState === "edit"
                                        )
                                      }
                                      defaultValue={
                                        formState === "edit"
                                          ? form.getFieldValue().freightTerm
                                          : null
                                      }
                                      className="w-100"

                                      allowClear
                                      filterSort={(optionA, optionB) =>
                                        optionA.children.toLowerCase().localeCompare(optionB.children.toLowerCase())
                                      }
                                    >
                                      {FreightTerm?.payload?.data.map(
                                        (freight) => {
                                          return (
                                            <Option
                                              value={freight.freight_term_id}
                                            >
                                              {freight.freight_term_name}
                                            </Option>
                                          );
                                        }
                                      )}
                                    </Select>
                                  </Form.Item>
                                </div>
                              </div>
                            </Bcol>
                            <Bcol lg={6} xl={4} xxl={3}>
                              <div className="customCol slc">
                                <div className="relative">
                                  <Form.Item
                                    name="bergenBilling"
                                    label="Bergen Billing:"
                                    labelAlign="left"
                                    labelCol={{ span: 8 }}
                                    wrapperCol={{ span: 16 }}
                                    rules={[
                                      {
                                        required: true,
                                        message: "Bergen Billing is required",
                                      },
                                    ]}
                                  >
                                    <Select
                                      size="small"
                                      showSearch
                                      optionFilterProp="children"
                                      onSearch={onSearch}
                                      filterOption={(input, options) =>
                                        options.children
                                          .toLowerCase()
                                          .indexOf(input.toLowerCase()) >= 0
                                      }
                                      filterSort={(optionA, optionB) =>
                                        optionA.children.toLowerCase().localeCompare(optionB.children.toLowerCase())
                                      }
                                      loading={BergenBillingOption?.loading}
                                      disabled={
                                        !(
                                          formState === "add" ||
                                          formState === "edit"
                                        )
                                      }
                                      defaultValue={
                                        formState === "edit"
                                          ? form.getFieldValue().bergenBilling
                                          : null
                                      }
                                      className="w-100"

                                      allowClear
                                    >
                                      {BergenBillingOption?.payload?.data?.map(
                                        (bill) => {
                                          return (
                                            <Option
                                              value={bill?.bergan_billing_id}
                                            >
                                              {bill?.bergan_billing_name}
                                            </Option>
                                          );
                                        }
                                      )}
                                    </Select>
                                  </Form.Item>
                                </div>
                              </div>
                            </Bcol>
                            <Bcol lg={6} xl={4} xxl={3}>
                              <div className="customCol slc">
                                <div className="relative">
                                  <Form.Item
                                    name="shipVia"
                                    label="Ship Via"
                                    labelAlign="left"
                                    labelCol={{ span: 8 }}
                                    wrapperCol={{ span: 16 }}
                                    rules={[
                                      {
                                        required: true,
                                        message: "Ship Via is required",
                                      },
                                    ]}
                                  >
                                    <Select
                                      size="small"
                                      showSearch
                                      optionFilterProp="children"
                                      onSearch={onSearch}
                                      filterOption={(input, options) =>
                                        options.children
                                          .toLowerCase()
                                          .indexOf(input.toLowerCase()) >= 0
                                      }
                                      filterSort={(optionA, optionB) =>
                                        optionA.children.toLowerCase().localeCompare(optionB.children.toLowerCase())
                                      }
                                      loading={ShipVia.loading}
                                      disabled={
                                        !(
                                          formState === "add" ||
                                          formState === "edit"
                                        )
                                      }
                                      defaultValue={
                                        formState === "edit"
                                          ? form.getFieldValue().shipVia
                                          : null
                                      }
                                      className="w-100"

                                      allowClear
                                    >
                                      {ShipVia?.payload?.data.map((ship) => {
                                        return (
                                          <Option
                                            key={ship.courier_service_id}
                                            value={ship.courier_service_id}
                                          >
                                            {ship.service_name}
                                          </Option>
                                        );
                                      })}
                                    </Select>
                                  </Form.Item>
                                </div>
                              </div>
                            </Bcol>

                            <Bcol lg={6} xl={4} xxl={3}>
                              <div className="customCol">
                                <div className="relative">
                                  <Form.Item
                                    name="accountNo"
                                    label="Shipping Account:"
                                    labelAlign="left"
                                    labelCol={{ span: 8 }}
                                    wrapperCol={{ span: 16 }}
                                    initialValue={
                                      formState === "add"
                                        ? null
                                        : form.getFieldValue().accountNo
                                    }

                                  >
                                    <Input
                                      size="small"
                                      className="styleInput b-radius-10"

                                      disabled={
                                        !(
                                          formState === "add" ||
                                          formState === "edit"
                                        )
                                      }
                                    />
                                  </Form.Item>
                                </div>
                              </div>
                            </Bcol>
                            <Bcol lg={6} xl={4} xxl={3}>
                              <div className="customCol slc">
                                <div className="relative">
                                  <Form.Item
                                    name="alcoholType"
                                    label="Alcohol Recepient:"
                                    labelAlign="left"
                                    labelCol={{ span: 8 }}
                                    wrapperCol={{ span: 16 }}
                                  >
                                    <Select
                                      size="small"
                                      defaultValue={
                                        formState === "edit"
                                          ? form.getFieldValue().alcoholType
                                          : null
                                      }

                                      disabled={
                                        !(
                                          formState === "add" ||
                                          formState === "edit"
                                        )
                                      }
                                      loading={customerSections.loading}
                                      className="w-100"
                                      allowClear
                                    >
                                      <Option value={"1"}>Consumer</Option>
                                      <Option value={"2"}>NonConsumer</Option>
                                    </Select>
                                  </Form.Item>
                                </div>
                              </div>
                            </Bcol>
                            {/* JAVED */}
                            <Bcol lg={6} xl={4} xxl={3}>
                              <div className="customCol">
                                <div className="relative">
                                  <Form.Item
                                    name="taxDuties"
                                    label="Tax Duties:"
                                    labelAlign="left"
                                    labelCol={{ span: 8 }}
                                    wrapperCol={{ span: 16 }}
                                    initialValue={
                                      formState === "add"
                                        ? null
                                        : form.getFieldValue().taxDuties
                                    }
                                  >
                                    <Input
                                      size="small"
                                      className="styleInput b-radius-10"

                                      disabled={
                                        !(
                                          formState === "add" ||
                                          formState === "edit"
                                        )
                                      }
                                    />
                                  </Form.Item>
                                </div>
                              </div>
                            </Bcol>
                            <Bcol lg={6} xl={4} xxl={3}>
                              <div className="customCol">
                                <div className="relative">
                                  <Form.Item
                                    name="shipToNonUs"
                                    label="Ship To Non Us:"
                                    labelAlign="left"
                                    labelCol={{ span: 8 }}
                                    wrapperCol={{ span: 16 }}
                                    initialValue={
                                      formState === "add"
                                        ? null
                                        : form.getFieldValue().shipToNonUs
                                    }
                                  >
                                    <Input
                                      size="small"
                                      className="styleInput b-radius-10"

                                      disabled={
                                        !(
                                          formState === "add" ||
                                          formState === "edit"
                                        )
                                      }
                                    />
                                  </Form.Item>
                                </div>
                              </div>
                            </Bcol>
                            <Bcol lg={6} xl={4} xxl={3}>
                              <div className="customCol">
                                <div className="relative">
                                  <Form.Item
                                    name="billToNonUs"
                                    label="Bill To Non Us:"
                                    labelAlign="left"
                                    labelCol={{ span: 8 }}
                                    wrapperCol={{ span: 16 }}
                                    initialValue={
                                      formState === "add"
                                        ? null
                                        : form.getFieldValue().billToNonUs
                                    }

                                  >
                                    <Input
                                      size="small"
                                      className="styleInput b-radius-10"

                                      disabled={
                                        !(
                                          formState === "add" ||
                                          formState === "edit"
                                        )
                                      }
                                    />
                                  </Form.Item>
                                </div>
                              </div>
                            </Bcol>

                            <Bcol lg={6} xl={4} xxl={3}>
                              <div className="firstSectionRo">
                                <Form.Item
                                  name="orderType"
                                  label="Order Type"
                                  labelAlign="left"
                                  labelCol={{ span: 8 }}
                                  wrapperCol={{ span: 16 }}
                                  rules={[
                                    {
                                      required: true,
                                      message: "Please Select OrderType",
                                    },

                                  ]}
                                >
                                  <Select
                                    size="small"
                                    tabIndex={1}
                                    autoComplete={"nope"}
                                    allowClear
                                    showSearch
                                    optionFilterProp="children"
                                    loading={
                                      saleOrderAdjustmentFormData.loading
                                    }

                                    defaultValue={
                                      form.getFieldValue().orderType
                                    }
                                    disabled={
                                      !(
                                        formState === "add" ||
                                        formState === "edit"
                                      )
                                    }
                                    onSearch={onSearch}
                                    ref={focusInput}
                                    filterOption={(input, options) =>
                                      options.children[1]
                                        .toLowerCase()
                                        .indexOf(input.toLowerCase()) >= 0
                                    }
                                    filterSort={(optionA, optionB) =>

                                      optionA.children[1].toLowerCase().localeCompare(optionB.children[1].toLowerCase())
                                    }
                                  >
                                    {saleOrderAdjustmentFormData?.payload?.scmOrderType.map(
                                      (item) => {
                                        return (
                                          <Option
                                            key={item.order_type_id}
                                            value={item.order_type_id}
                                          >
                                            {" "}
                                            {`${item.order_type_name}`}
                                          </Option>
                                        );
                                      }
                                    )}
                                  </Select>
                                </Form.Item>
                              </div>
                            </Bcol>
                            <Bcol lg={6} xl={4} xxl={3}>
                              <div className="customCol slc">
                                <div className="relative mx-10">
                                  <Form.Item
                                    name="isComplete"
                                    valuePropName="checked"

                                    labelCol={{ span: 8 }}
                                    wrapperCol={{ span: 16 }}
                                  >
                                    <Checkbox
                                      disabled={
                                        !(
                                          formState === "add" ||
                                          formState === "edit"
                                        )
                                      }
                                      className="styleInput"
                                    >
                                      Ship Complete
                                    </Checkbox>
                                  </Form.Item>
                                </div>
                              </div>
                            </Bcol>
                            <Bcol lg={6} xl={4} xxl={3}>
                              <div className="customCol">
                                <div className="relative mx-10">
                                  <Form.Item
                                    name="isApproved"
                                    valuePropName="checked"
                                    labelAlign="left"
                                    labelCol={{ span: 8 }}
                                    wrapperCol={{ span: 16 }}
                                  >
                                    <Checkbox
                                      disabled={
                                        !(
                                          formState === "add" ||
                                          formState === "edit"
                                        )
                                      }
                                      className="styleInput"
                                    >
                                      Approved
                                    </Checkbox>
                                  </Form.Item>
                                </div>
                              </div>
                            </Bcol>
                            <Bcol lg={6} xl={4} xxl={3}>
                              <div className="customCol">
                                <div className="relative mx-10">
                                  <Form.Item
                                    name="isactive"
                                    valuePropName="checked"
                                    labelAlign="left"
                                    labelCol={{ span: 8 }}
                                    wrapperCol={{ span: 16 }}
                                  >
                                    <Checkbox
                                      disabled={
                                        !(
                                          formState === "add" ||
                                          formState === "edit"
                                        )
                                      }
                                      className="styleInput"
                                    >
                                      Active
                                    </Checkbox>
                                  </Form.Item>
                                </div>
                              </div>
                            </Bcol>
                            <Bcol lg={6} xl={4} xxl={3}>
                              <div className="customCol">
                                <div className="relative mx-10">
                                  <Form.Item
                                    name="min_surcharge_waived"
                                    valuePropName="checked"
                                    labelAlign="left"
                                    labelCol={{ span: 8 }}
                                    wrapperCol={{ span: 16 }}
                                  >
                                    <Checkbox
                                      disabled={
                                        !(
                                          formState === "add" ||
                                          formState === "edit"
                                        )
                                      }
                                      className="styleInput"
                                    >
                                      Min Surcharge Waived
                                    </Checkbox>
                                  </Form.Item>
                                </div>
                              </div>
                            </Bcol>
                            <Bcol lg={6} xl={4} xxl={3}>
                              <div className="customCol">
                                <div className="relative mx-10">
                                  <Form.Item
                                    name="high_priority_account"
                                    valuePropName="checked"
                                    labelAlign="left"
                                    labelCol={{ span: 8 }}
                                    wrapperCol={{ span: 16 }}
                                  >
                                    <Checkbox
                                      disabled={
                                        !(
                                          formState === "add" ||
                                          formState === "edit"
                                        )
                                      }
                                      className="styleInput"
                                    >
                                      High Priority Account
                                    </Checkbox>
                                  </Form.Item>
                                </div>
                              </div>
                            </Bcol>
                            <Bcol lg={6} xl={4} xxl={3}>
                              <div className="customCol">
                                <div className="relative mx-10">
                                  <Form.Item
                                    name="complete_naf"
                                    valuePropName="checked"
                                    labelAlign="left"
                                    labelCol={{ span: 8 }}
                                    wrapperCol={{ span: 16 }}
                                  >
                                    <Checkbox
                                      disabled={
                                        !(
                                          formState === "add" ||
                                          formState === "edit"
                                        )
                                      }
                                      className="styleInput"
                                    >
                                      Complete NAF
                                    </Checkbox>
                                  </Form.Item>
                                </div>
                              </div>
                            </Bcol>
                          </Brow>
                        </div>

                        {/* <div className="customRow-Customer">
                          </div> */}
                      </Form>
                    </div>
                  </TabPane>
                  <TabPane
                    tab="Related Transactions"
                    key="relatedTransactions"
                    disabled={formState === "view" || formState === "add"}
                  >
                    <div className="tabs">
                      <Tables
                        type="company"
                        scrollX={"50rem"}
                        scroll={360}
                        perPage={15}
                        source={relatedTrans}
                        col={relatedTransactions}

                        paginate
                      />
                    </div>
                  </TabPane>
                  <TabPane
                    tab="Communication"
                    key="communication"
                    disabled={formState === "view" || formState === "add"}
                  >
                    <Collapse
                    // defaultActiveKey={["1"]}
                    >
                      <Panel header={<div className="communication_accordian" >
                        <div>Customer Profile Form ({getUploadCount("Customer Profile Form")})</div>
                        <div><Button
                          disabled={formState !== "edit"}
                          onClick={(e) => {
                            setIsModalVisible(true);
                            setFolderType("Customer Profile Form");
                            e.stopPropagation()
                          }}>Upload File</Button></div>
                      </div>} key="1">
                        {renderUploadData("Customer Profile Form")}

                      </Panel>
                      <Panel
                        header={<div className="communication_accordian" >
                          <div>Credit Card Authorisation Form ({getUploadCount("Credit Card Authorisation Form")})</div>
                          <div><Button
                            disabled={formState !== "edit"}
                            onClick={(e) => {
                              setIsModalVisible(true);
                              setFolderType("Credit Card Authorisation Form");
                              e.stopPropagation()
                            }}>Upload File</Button></div>
                        </div>}
                        key="2">
                        {renderUploadData("Credit Card Authorisation Form")}
                      </Panel>
                      <Panel
                        header={<div className="communication_accordian" >
                          <div>Resale/Tax Certificate ({getUploadCount("Resale/Tax Certificate")})</div>
                          <div><Button
                            disabled={formState !== "edit"}
                            onClick={(e) => {
                              setIsModalVisible(true);
                              setFolderType("Resale/Tax Certificate");
                              e.stopPropagation()
                            }}>Upload File</Button></div>
                        </div>}
                        key="3">
                        {renderUploadData("Resale/Tax Certificate")}
                      </Panel>
                      <Panel
                        header={<div className="communication_accordian" >
                          <div>W9 Form ({getUploadCount("W9 Form")})</div>
                          <div><Button
                            disabled={formState !== "edit"}
                            onClick={(e) => {
                              setIsModalVisible(true);
                              setFolderType("W9 Form");
                              e.stopPropagation()
                            }}>Upload File</Button></div>
                        </div>}
                        key="4">
                        {renderUploadData("W9 Form")}
                      </Panel>
                      <Panel
                        header={<div className="communication_accordian" >
                          <div>Consignment Contract ({getUploadCount("Consignment Contract")})</div>
                          <div><Button
                            disabled={formState !== "edit"}
                            onClick={(e) => {
                              setIsModalVisible(true);
                              setFolderType("Consignment Contract");
                              e.stopPropagation()
                            }}>Upload File</Button></div>
                        </div>}
                        key="5">
                        {renderUploadData("Consignment Contract")}
                      </Panel>
                      <Panel
                        header={<div className="communication_accordian" >
                          <div>Shipping Guideline ({getUploadCount("Shipping Guideline")})</div>
                          <div><Button
                            disabled={formState !== "edit"}
                            onClick={(e) => {
                              setIsModalVisible(true);
                              setFolderType("Shipping Guideline");
                              e.stopPropagation()
                            }}>Upload File</Button></div>
                        </div>}
                        key="6">
                        {renderUploadData("W9 Form")}
                      </Panel>
                      <Panel
                        header={<div className="communication_accordian" >
                          <div>Credit Reference ({getUploadCount("Credit Reference")})</div>
                          <div><Button
                            disabled={formState !== "edit"}
                            onClick={(e) => {
                              setIsModalVisible(true);
                              setFolderType("Credit Reference");
                              e.stopPropagation()
                            }}>Upload File</Button></div>
                        </div>}
                        key="7">
                        {renderUploadData("Credit Reference")}
                      </Panel>
                      <Panel
                        header={<div className="communication_accordian" >
                          <div>Routing Guide ({getUploadCount("Routing Guide")})</div>
                          <div><Button
                            disabled={formState !== "edit"}
                            onClick={(e) => {
                              setIsModalVisible(true);
                              setFolderType("Routing Guide");
                              e.stopPropagation()
                            }}>Upload File</Button></div>
                        </div>}
                        key="8">
                        {renderUploadData("Routing Guide")}
                      </Panel>
                    </Collapse>
                  </TabPane>
                  {(formState === "edit" || formState === "formView") && (
                    <TabPane tab="System Information" key="logs">
                      <div className="tabs">
                        {systemLog?.payload?.data?.length > 0 && (
                          <Tables
                            type="company"
                            scrollX={"50rem"}
                            scroll={360}
                            perPage={15}
                            source={systemLog?.payload?.data}
                            dataSource={[]}
                            col={renderColumns()}
                            load={systemLog?.loading}
                            paginate
                          />
                        )}
                      </div>
                    </TabPane>
                  )}
                </Tabs>
                <Modal
                  width={750}
                  title={`Add New Document in (${folderType})`}
                  visible={isModalVisible}
                  onOk={() => {
                    const newErrors = {};
                    if (!fileRemark) {
                      newErrors.remarks = "Please enter Remarks";
                    }
                    if (!documentType) {
                      newErrors.documentType = "Please select document type";
                    }
                    if (!fileList.length) {
                      newErrors.file = "Please upload a file";
                    }
                    setErrors(newErrors);
                    // stop if any errors
                    if (Object.keys(newErrors).length > 0) return;
                    dispatch(addCustomerUpload({ token, customer_id: customerID, remarks: fileRemark, file_type: documentType, file: fileList, document_type: folderType })).then((res) => {
                      if (res.type === "ADD_CUSTOMER_UPLAOD_SUCCESS") {
                        Swal.fire({
                          icon: "success",
                          title: "Success...",
                          text: `File Uploaded in ${folderType}`,
                        })
                        dispatch(getCustomerUpload(token, customerID))
                      } else if (res.type === "ADD_CUSTOMER_UPLAOD_ERROR") {
                        Swal.fire({
                          icon: "error",
                          title: "OOPS...",
                          text: `SomeThing Went Wrong`,
                        })
                      }
                    })
                    // reset & close modal
                    setIsModalVisible(false);
                    setFileRemark("");
                    setDocumentType(null);
                    setFolderType(null);
                    setFileList([]);
                    setErrors({});
                  }}
                  onCancel={() => {
                    setIsModalVisible(false);
                    setFileRemark("");
                    setDocumentType(null);
                    setFolderType(null);
                    setFileList([]);
                    setErrors({});
                  }}
                >
                  {/* Document Name */}
                  <div style={{ marginBottom: 16 }}>
                    <p>
                      Remarks: <span style={{ color: "red" }}>*</span>
                    </p>
                    <Input
                      placeholder="Enter Remarks"
                      value={fileRemark}
                      onChange={(e) => setFileRemark(e.target.value)}
                    />
                    {errors.remarks && (
                      <div style={{ color: "red", marginTop: 4 }}>{errors.remarks}</div>
                    )}
                  </div>

                  {/* Document Type */}
                  <div style={{ marginBottom: 16 }}>
                    <p>
                      Select Document Type: <span style={{ color: "red" }}>*</span>
                    </p>
                    <Select
                      placeholder="Choose type"
                      value={documentType}
                      style={{ width: "100%" }}
                      onChange={(value) => setDocumentType(value)}
                    >
                      <Option value="pdf">PDF</Option>
                      <Option value="doc">Document</Option>
                      <Option value="image">Image</Option>
                    </Select>
                    {errors.documentType && (
                      <div style={{ color: "red", marginTop: 4 }}>{errors.documentType}</div>
                    )}
                  </div>

                  {/* File Upload */}
                  <div>
                    <p>
                      Upload File <span style={{ color: "red" }}>*</span>
                    </p>
                    <Dragger {...uploadProps} fileList={fileList}>
                      <p className="ant-upload-drag-icon">
                        <InboxOutlined />
                      </p>
                      <p className="ant-upload-text">Click or drag file to this area to upload</p>
                      <p className="ant-upload-hint">
                        Only {documentType?.toUpperCase() || "selected"} file type is accepted.
                      </p>
                    </Dragger>
                    {errors.file && (
                      <div style={{ color: "red", marginTop: 4 }}>{errors.file}</div>
                    )}
                  </div>
                </Modal>

                {/* Image Preview */}
                <Modal
                  visible={fileViewModalOpen}
                  onCancel={() => setIsFileViewModalOpen(false)}
                  footer={null}
                  width={800} // modal ka size
                >
                  <div style={{ marginTop: 20 }}>
                    {fileType === "jpg" ||
                      fileType === "jpeg" ||
                      fileType === "png" ||
                      fileType === "gif" ? (
                      <Image
                        preview={false}
                        width={"100%"}
                        src={selectedFile?.upload_file_url}
                      />
                    ) : fileType === "pdf" ? (
                      <iframe
                        src={selectedFile?.upload_file_url}
                        title="PDF Preview"
                        style={{ width: "100%", height: "80vh", border: "none" }}
                      />
                    ) : fileType === "docx" ||
                      fileType === "doc" ||
                      fileType === "xlsx" ||
                      fileType === "pptx" ? (
                      <iframe
                        src={`https://docs.google.com/gview?url=${selectedFile?.upload_file_url}&embedded=true`}
                        title="Document Preview"
                        style={{ width: "100%", height: "80vh", border: "none" }}
                      />
                    ) : (
                      <p>Unsupported file type</p>
                    )}
                  </div>
                </Modal>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    {/* </div> */}
  </>;
}
